import React from 'react'
import { Button, Form, Image, Modal } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import { AddConsentForm } from '../Consent/AddConsentForm';

export const EditModal = ({showOtpModal, setShowOtpModal, data, fetchData}) => {
    const handleCloseModal = () => setShowOtpModal(false);
    return (
        <Modal
            show={showOtpModal}
            onHide={handleCloseModal}
            backdrop="static"
            keyboard={false}
            size="md"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Edit Consent</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <AddConsentForm type="edit" initialData={data} handleCloseModal={handleCloseModal} fetchData={fetchData}/>
            </Modal.Body>
            {/* <Modal.Footer className='border-0 px-4 pb-4'>
                <Button
                    variant="dark"
                    className='w-100'
                    onClick={handleCloseModal}
                >
                    Confirm
                </Button>
            </Modal.Footer> */}
        </Modal>
    )
}
